import styled from "@emotion/styled";
import { type MantineTheme } from "@mantine/core";

interface IWidgetContainer {
  disabled?: boolean;
  theme?: MantineTheme;
}
interface IDashboardCardContainer {
  disabled?: boolean;
  theme?: MantineTheme;
}

export const WidgetContainer = styled.div<IWidgetContainer>`
  border-radius: 4px;
  width: 100%;
  min-height: 180px;
  height: auto;
  background-color: ${({ theme, disabled }) =>
    !disabled && theme ? theme.colors.cardBackground[0] : "#DEE2E6"};
  box-shadow: ${({ theme }) => `${theme.colors.cardBoxShadow[0]} 0px 3px 8px`};
  transition: box-shadow 0.2s;
  color: ${({ theme }) => theme.colors.main};
  padding: 20px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: start;
  border-right: 5px solid ${({ theme }) => theme.colors.main[9]};
  cursor: ${({ disabled }) => (!disabled ? "select" : "not-allowed")};

  &:hover {
    box-shadow: ${({ theme, disabled }) =>
        !disabled
          ? theme.colorScheme === "dark"
            ? theme.colors.cardBoxShadow[0]
            : "rgba(0, 0, 0, 0.24)"
          : "none"}
      0px 5px 18px;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    min-height: 150px;
  }
`;

export const DashboardCardContainer = styled.div<IDashboardCardContainer>`
  border-radius: 4px;
  width: 100%;
  min-height: 180px;
  background-color: ${({ theme }) => theme.colors.cardBackground[0]};
  color: ${({ theme }) => theme.colors.main};
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  transition:
    box-shadow 0.2s,
    background-color 0.2s;
  cursor: ${({ disabled }) => (!disabled ? "select" : "not-allowed")};
`;
